/* eslint-disable linebreak-style */
import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Carousel, {Dots} from '@brainhubeu/react-carousel';
import styled from '@emotion/styled';
import BackButtonComponent from '../shared/BackButtonComponent';
import { addToCart, getCatalogueProduct, getResourceFile, getCatalogue } from '../../network';
import { setCart } from '../../redux/actions/CartActions';
import { formatPrice } from '../../helpers/Helper';
import { isLoggedInCustomer } from '../../utils/auth';
import LoadingComponent from '../shared/LoadingComponent';
import '@brainhubeu/react-carousel/lib/style.css';
import DropdownContainer from '../shared/DropdownComponent';
import ProductReviews from '../Customer Review/index';
import ProductItem from '../ProductItem';

const Layout = styled.div`
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    
    margin-top: 5rem;
    margin-bottom: 6rem;

    @media (max-width: 768px){

        grid-template-columns:auto;
    }
`;

const ProductDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const ProductConfigurationContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;

    @media (max-width: 800px){
       
    }
`;

const AliasContainer = styled.div`
    display: flex;
    flex-direction: column;

    padding: var(--space-40);
    margin-top: var(--space-40);

    > .title {
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--font-20);
        color: var(--color-neutral-gray-600);
    }

    > .text {
        margin-top: var(--space-16);
        font-weight: normal;
        font-size: var(--font-18);
        line-height: var(--font-18);
        color: var(--color-neutral-gray-900);
    }
`;

const Title = styled.h1`
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-20);
    color: var(--color-neutral-gray-900);
`;

const Brand = styled.span`
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-20);
    color: var(--color-neutral-gray-900);
`;

const AttributeRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    
    margin-top: var(--space-20);
    margin-bottom: var(--space-20);
    
    > .title {
      width: var(--space-72);
      margin-right: var(--space-32);
      
      font-weight: 500;
      font-size: var(--font-16);
      line-height: var(--font-16);
      
      color: #969696;
    }
`;

const Price = styled.div`
  display: flex;
  flex-direction: row;
  
  align-items: center;
  
  > .current {
    color: var(--color-blue-600);
    font-size: var(--font-20);
    line-height: var(--font-20);
    font-weight: 600;
    
    margin-right: var(--space-8);
  }
  
  > .strikethrough {
    color: var(--color-gray-500);
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: 600;
  }
`;

const Divider = styled.div`
    width: 80%;
    height: 1px;
    background: var(--color-gray-400);
`;

const StockLabel = styled.span`
    // todo: pass props to change color when running out of stock or out of stock
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: bold;
    color: var(--color-green-600);
`;

const SelectionText = styled.span`
    font-weight: 500;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: var(--color-neutral-gray-900);
`;

const QuantityContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 80%;
    height: 10.25rem;
    
    
    background: var(--color-neutral-gray-100);
    border: 1px solid var(--color-neutral-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-12);

    @media (max-width: 500px){
        width: 100%;
    }
`;

const QuantityInnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    
    > span {
        font-style: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);
        font-weight: 500;
        
        color: var(--color-neutral-gray-700)
    }
`;

const Quantity = styled.select`
    padding: var(--space-6);
    width: 12rem;
    height: 2.25rem;
    
    background: white;
    
    margin-top: var(--space-8);
    margin-bottom: var(--space-12);
    
    border: 2px solid var(--color-neutral-gray-500);
    box-sizing: border-box;
    border-radius: var(--space-6);
`;

const QuantityStepperContainer = styled.div`
    display: flex;
    flex-direction: row;
    
    justify-content: space-between;
    align-items: center;
    
    width: 12rem;
    height: 2.25rem;
    
    background: var(--color-gray-100);
    
    margin-top: var(--space-8);
    margin-bottom: var(--space-12);
    
    border: 1px solid var(--color-gray-400);
    box-sizing: border-box;
    border-radius: var(--space-6);
    
    > input {
      width: 50%;
      height: -webkit-fill-available;
      padding: var(--space-6);
      border-radius: var(--space-6) 0 0 var(--space-6);
    }
    
    > button {
      width: 50%;
      height: -webkit-fill-available;
      color: white;
      background: var(--color-orange-500);
      border-radius: 0 var(--space-6) var(--space-6) 0;
    }
`;

const AddCartButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 12rem;
    height: 2.25rem;
    
    font-weight: 600;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: white;
    
    border: none;
    background: var(--color-orange-500);
    box-shadow: 0 4px 6px rgba(156, 66, 33, 0.12), 0 2px 4px rgba(237, 137, 54, 0.32);
    transition: background-color 0.3s ease-in;
    border-radius: 0.25rem;
    
    cursor: pointer;
    
    &:hover {
        background: var(--color-orange-400);
    }
    
    &:disabled {
        background: var(--color-gray-400);
        box-shadow: none;
    }
`;

const BackButtonContainer = styled.div`
    margin-bottom: var(--space-32);
`;

// Slideshow Styled Components
const SlideshowMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > span {
        margin-top: var(--space-16);
        margin-bottom: var(--space-20);

        font-size: var(--font-16);
        line-height: var(--font-16);

        color: var(--color-neutral-gray-600);
        padding-left: 6rem;
    }
`;

const SlideSelectedResourceContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    width: 25rem;
    height: 25rem;
    
    background: white;
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 0.5rem;

    > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        padding: 2.5rem;
    }

    > video {
        width: 100%;
        height: 100%;
        padding: 0;

        object-fit: contain;
    }
`;

const ProductImageContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
position: relative;

width: 25rem;
height: 25rem;

background-color: var(--color-white);

.BrainhubCarousel__dot--selected:before {
    content: '';
    width: 10px !important;
    height: 10px !important;
    background: var(--company-dark) !important;
}
.BrainhubCarousel__dot:before {
    content: '';
    width: 10px !important;
    height: 10px !important;
    background: var(--color-gray-400);
}
.BrainhubCarousel__dot:focus {
  outline: none;
  border: 0;
  box-shadow: none !important;
}

> .close {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;

    width: var(--space-24);
    height: var(--space-24);

    font-size: var(--font-12);
    line-height: var(--font-12);
    color: var(--color-gray-700);

    background: var(--color-gray-100);
    border: 1px solid var(--color-gray-600);
    box-sizing: border-box;

    border-radius: var(--space-20);
    left: 3.25rem;
    top: 3.25rem;

    cursor: pointer;
}

> .badge {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        
        width: auto;
        height: var(--space-18);
        min-width: var(--space-18);
        
        font-size: var(--font-12);
        line-height: var(--font-12);
        
        background: white;
        border: 1px solid var(--color-gray-500);
        box-sizing: border-box;
        box-shadow: none;
        
        border-radius: 0.625rem;
        left: 3.25rem;
        top: 3.25rem;
        margin: 0;
    }

> div.image-container {
        display: flex;
        align-items: center;
        justify-content: center;
    
    width: 100%;
    height: 100%;

    overflow: hidden;

    border: ${props => (props.selected ? '1px solid var(--company-dark)' : '1px solid var(--color-gray-300)')};
    box-sizing: border-box;
    border-radius: var(--space-8);

    > img {
        width: 100%;
        object-fit: cover;
    }

    > video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

        > span {
            display: flex;
            align-items: center;
            justify-content: center;
            
            width: 100%;
            height: 100%;
            
            background: var(--color-gray-100);
            border-radius: 0.5rem;
            
            color: var(--color-gray-700);
            
            font-size: 0.75rem;
            line-height: 0.75rem;
            font-weight: 500;
        }
}
    @media (max-width: 500px){
        width: 22rem;
        height: 20rem;
       
        
        
    }
`;

const ThumbnailContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: var(--space-12);
`;

const ThumbnailItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 4.5rem;
    height: 4rem;

    background: white;

    border: ${props => (props.selected ? '1px solid var(--company-dark)' : '1px solid #B8B8B8')};
    box-sizing: border-box;
    border-radius: 0.5rem;

    //margin-left: var(--space-12);
    //margin-right: var(--space-12);

    cursor: pointer;

    > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        padding: 0.25rem;
    }

    > video {
        width: 100%;
        height: 100%;
        padding: 0;

        object-fit: cover;
    }
`;

// Option Styled Components
const OptionsContainer = styled.div`
    display: grid;
    grid-gap: var(--space-8);
`;

const OptionButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 12rem;
    height: 2.25rem;
    
    color: ${props => (props.disabled ? 'var(--color-gray-400)' : props.selected ? 'var(--color-green-700)' : 'var(--color-neutral-gray-900)')};
    
    font-size: var(--font-16);
    line-height: var(--font-16);
    font-weight: ${props => (props.selected ? 'bold' : 'normal')};
    
    background: ${props => (props.disabled ? 'var(--color-gray-100)' : props.selected ? 'var(--color-green-100)' : 'white')};
    border: ${props => (props.disabled ? '1px solid var(--color-gray-300)' : props.selected ? '2px solid var(--color-green-600)' : '1px solid var(--color-neutral-gray-500)')};
    box-sizing: border-box;
    border-radius: var(--space-6);
    
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    
    &:hover {
        background: ${props => (props.disabled ? 'var(--color-gray-200)' : 'var(--color-green-100)')};
    }
`;

const DetailWrapper = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-template-rows: auto 1fr;
    justify-content: center;
`;

const DescriptionContainer = styled.div`
    width: auto;;
    display: flex;
    flex-direction: column;

`;

const SimilarItemsContainer = styled.div`

    width: auto;
    height: auto;


    background: var(--color-neutral-gray-100);

    h1{
        padding-top: 2rem;
        padding-left: 2rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--space-20);

        display: flex;
        align-items: center;


        color: var(--color-neutral-gray-900);
    }
    .items{
        padding-top: 2rem;
        padding-bottom: 2rem;
        display: flex;
        /* grid-auto-flow: column; */
        gap: 1rem;
        flex-wrap: wrap;
        justify-content: center;
    }
    @media (max-width: 500px){
        h1{
            font-size: var(--font-16);
            font-weight: 400;
        }
      
    }
`;
const DescriptionHeader = styled.div`
    width: auto;
    height: var(--space-48);
    display: flex;
    flex-direction: row;
    background-color: #EDEDED;

  
    
    h1{
            position: relative;
            left: 1.5rem;
            top: 1rem;
            font-family: Inter,sans-serif;
            font-style: normal;
            font-weight: 500;
            font-size: var(--font-20);
            line-height: var(--space-20);
            color: var(--color-black);
            padding: var(--space-12) var(--space-16);
            justify-content:center;
            border-radius: var(--space-8) var(--space-8) 0px 0px;
            cursor: pointer;
    }

        >  .active{
                background-color: var(--color-white);
                cursor: default;
            }
        >  .next-active{
            background-color: var(--color-white);
            cursor: default;
        }
        > .active:before{
            position: absolute;
            width: var(--space-8);
            height: var(--space-12);
            top: 1.4rem;
            right: 8.2rem;
            content:" ";
        
            background-color: transparent;
            border-radius: 0px 0px 8px 0px;
            box-shadow: 0px 6px 0px 0px white;
        }
       > .active:after{
            position: absolute;
            width: var(--space-8);
            height: var(--space-12);
            top: 1.4rem;
            left: 8.2rem;

            content:" ";

            background-color: transparent;
            border-radius: 0px 0px 0px 8px;
            box-shadow: 0px 6px 0px 0px white;
        }

        > .next-active:before{
            position: absolute;
            width: var(--space-8);
            height: var(--space-12);
            top: 1.4rem;
            right: 6.9rem;
            content:" ";
        
            background-color: transparent;
            border-radius: 0px 0px 8px 0px;
            box-shadow: 0px 6px 0px 0px white;
        }
       > .next-active:after{
            position: absolute;
            width: var(--space-8);
            height: var(--space-12);
            top: 1.4rem;
            left: 6.9rem;

            content:" ";

            background-color: transparent;
            border-radius: 0px 0px 0px 8px;
            box-shadow: 0px 6px 0px 0px white;
        }
    
   @media (max-width: 500px){
       h1{
           
       }
   }
    
`;

const DescriptionSection = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 2rem;
    div{
        width: auto;
        height: 10rem;
        padding-left: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        > h1{
            font-family: Inter,sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: var(--font-36);
            line-height: var(--space-36);
            color: #000000;
        }
        > p{
            font-family: Inter,sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: var(--font-16);
            line-height: var(--space-24);


            color: #000000;
        }
    }

    @media (max-width: 500px){
        div{
            h1{
                font-size: var(--font-28);
            }
            p{
                font-size: var(--font-12);
            }
        }
    }
`;

const DescriptionDivider = styled.div`
    width: auto;
    height: 1px;
    background: var(--color-gray-400);
`;

const CompareContainer = styled.div`
    width: auto;
    display: flex;
    flex-direction: column;
    background: #F7F7F7;
    height: auto;
    margin-bottom: 5rem;

    h1{
        padding-left: 2rem;
        padding-top: 1.8rem;
        padding-bottom: 2rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-36);
        line-height: var(--space-36);

        display: flex;
        align-items: center;

        color: var(--color-black);
    }
    .compare{
        display: grid;
        grid-auto-flow: column;
        grid-gap: 1.5rem;
    }
    .compareItem{
        display: flex;
        flex-direction: column;
    }
    .company{
        font-family: Inter;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-16);
        line-height: var(--space-24);

        display: flex;
        align-items: center;
        text-align: center;

        color: var(--color-neutral-gray-900);

        flex: none;
        order: 0;
        align-self: center;
        margin: 0px var(--space-20);
    }
    @media (max-width: 500px){
        h1{
            font-size: var(--font-28);
        }
    }
`;

const MobileImageContainer = styled.div`
    display: flex;
    width: 22rem;
    height: 20rem;
    position: relative;
    background: #FFFFFF;
    justify-content: center;
/* default/gray/300 */

    border: 1.61608px solid #D3D9DE;
    box-sizing: border-box;
    border-radius: var(--space-14);

    img{
        align-self: center;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    video{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
   
`;
let myAliases = [];
const Description = () => {
    const params = useParams();
    const { id } = params;
    const [selected, setSelected] = useState(false);
    const [product, setProduct] = useState(null);
    const searchText = myAliases[1] || myAliases[0];
    let active = 'active';

    useEffect(() => {
        const retrieveProduct = async () => {
            // setLoading(true);
            getCatalogue(searchText, '', '', 1, 2)
                .then(result => {
                    setProduct([...result.data]);

                })
                .catch(error => console.error(error))
        };
        retrieveProduct();
    }, []);

    return (
        <DescriptionContainer>
            <DescriptionDivider />
            <SimilarItemsContainer>
                <h1>Customers who viewed this item also viewed</h1>
                <div className="items">
                    {product?.map((value, index) => {
                        return (
                            <ProductItem itemSmall product={value} shadow={true}/>
                        )
                    })}
                </div>
            </SimilarItemsContainer>
            <DescriptionHeader>
                {!selected ?
                    (
                        <>
                            <h1 className="active">Description</h1>
                            <h1 onClick={() => setSelected(true)}>Features</h1>
                        </>
                    )
                    :
                    <>
                        <h1 onClick={() => setSelected(false)}>Description</h1>
                        <h1 className="next-active">Features</h1>
                    </>
                }

            </DescriptionHeader>
            <DescriptionSection>
                {!selected ? (
                    <div style={{ paddingBottom: '2rem' }}>
                        <h1>Description</h1>
                        <p> The Achieve™ programmable automatic biopsy system ensures maximum sample capture
                        whilst maintaining tissue architecture. Designed for fast, accurate tissue penetration,
                    Achieve™ combines quality sampling capability with precision and control for accurate diagnosis.</p>
                    </div>
                  )
                    :
                    <div>
                        <h1>Features</h1>
                    </div>
                }
            </DescriptionSection>
            <DescriptionDivider style={{ marginBottom: '2rem' }} />
            <CompareContainer>
                <h1>Compare Prices</h1>
                <div className="compare" />

            </CompareContainer>

            <ProductReviews id={id}/>
        </DescriptionContainer>
    );
}

function Slideshow({ media, width }) {
    const history = useHistory();
    const [selectedMedia, setSelectedMedia] = useState({});
    let mediaArray = [];
    const [selectedThumbnailIndex, setSelectedThumbnailIndex] = useState(0);


    useEffect(() => {
        if (media.length) setSelectedMedia(media[selectedThumbnailIndex]);
        media.map((item) => mediaArray.push(item));
    }, [media, selectedThumbnailIndex]);


    return <SlideshowMainContainer>
        {width < 500 ?
            <ProductImageContainer style={{ marginBottom: '2rem' }}>
                <Carousel
                    dots
                >
                    {media.map((item, index) =>
                        <div key={index}>
                            {item.type === 'image' && <MobileImageContainer><img src={getResourceFile(item.resource)} alt="productItemImage" /></MobileImageContainer>}
                            {item.type === 'video' && <MobileImageContainer><video src={getResourceFile(item.resource)} /></MobileImageContainer>}

                        </div>
                    )}
                </Carousel>
            </ProductImageContainer>
            :
            <>
                <ProductImageContainer>
                    <div className="image-container">
                        {selectedMedia.type === 'image' && <img src={getResourceFile(selectedMedia.resource)} alt="productImage" />}
                        {selectedMedia.type === 'video' && <video autoPlay src={getResourceFile(selectedMedia.resource)} controls />}
                    </div>
                </ProductImageContainer>


                <span>Roll over or tap to view image</span>
                <ThumbnailContainer>

                    {
                        media.map((item, index) => {
                            return <ProductImageContainer
                                key={`ThumbnailItem_${index}`}
                                selected={index === selectedThumbnailIndex}
                                onClick={() => setSelectedThumbnailIndex(index)}
                                onMouseOver={() => setSelectedThumbnailIndex(index)}
                                style={{
                                    width: '4.5rem',
                                    height: '4.5rem',
                                    cursor: 'pointer'
                                }}>
                                <div className="image-container">
                                    {item.type === 'image' && <img src={getResourceFile(item.resource)} alt="productItemImage" />}
                                    {item.type === 'video' && <video src={getResourceFile(item.resource)} />}
                                </div>
                            </ProductImageContainer>;

                            // return <ThumbnailItem key={`ThumbnailItem_${index}`} selected={index === selectedThumbnailIndex}
                            //                       onClick={e => setSelectedThumbnailIndex(index)} onMouseOver={e => setSelectedThumbnailIndex(index)}>
                            //     {item.type === 'image' && <img src={getResourceFile(item.resource)} alt="productItemImage"/>}
                            //     {item.type === 'video' && <video src={getResourceFile(item.resource)}/>}
                            // </ThumbnailItem>;
                        })
                    }
                </ThumbnailContainer>
            </>
        }
    </SlideshowMainContainer>;
}

function Option({ option, onOptionClick, matches, width }) {
    const { title, options } = option;
    const [selectedIndex, setSelectedIndex] = useState(0);


    const checkIfDisabled = (opt, index) => {
        if (matches.length > 0 && !matches.includes(opt)) {
            if (index === selectedIndex) {
                onOptionClick('');
                setSelectedIndex(-1);
            }
            return true;
        }
    };

    // useEffect(() =>{
    //     onOptionClick(options[0])
    // },[])

    return <>
        {
            options && options.length !== 0 && <AttributeRow style={{
                alignItems: 'baseline'
            }}>
                <span className="title">{title}:</span>
                {width < 500 ?
                    <DropdownContainer onChange={(e) => onOptionClick(e.target.value)}>
                        {options.map((opt, index) => {

                            return <option key={`Option_${index}`}
                                selected={selectedIndex === index}
                            >{opt}</option>
                        })}
                    </DropdownContainer>
                    :
                    <OptionsContainer>
                        {
                            options.map((opt, index) => {
                                return <OptionButton
                                    key={`OptionButton_${index}`}
                                    selected={selectedIndex === index}
                                    disabled={checkIfDisabled(opt, index)}
                                    onClick={() => {
                                        if (checkIfDisabled(opt, index)) return;

                                        onOptionClick(selectedIndex === index ? '' : opt);
                                        setSelectedIndex(selectedIndex === index ? -1 : index);
                                    }}>
                                    {opt}
                                </OptionButton>;
                            })
                        }
                    </OptionsContainer>
                }
            </AttributeRow>
        }
    </>;
}

function ProductDetails({ auth, setCart }) {
    const location = useLocation();
    const history = useHistory();
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState(null);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [media, setMedia] = useState([]);
    const [attribute, setAttribute] = useState('');
    const [size, setSize] = useState('');
    const [isCustomQuantity, setIsCustomQuantity] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [customQuantity, setCustomQuantity] = useState(1);

    const [validAttributeOptions, setValidAttributeOptions] = useState([]);
    const [validSizeOptions, setValidSizeOptions] = useState([]);
    const [canvasWidth, setCanvasWidth] = useState(0);

    useEffect(() => {
        handleResize();
    });
    const handleResize = () => {
        console.log('resized to: ', window.innerWidth, 'x', window.innerHeight);
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    };

    useEffect(() => {
        const retrieveProduct = async () => {
            setLoading(true);
            const { id } = params;
            try {
                const product = await getCatalogueProduct(id);
                setProduct(product);
                myAliases = product?.aliases;
            } catch (error) {
                // todo: show error on screen; unable to retrieve product
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        retrieveProduct();
    }, []);

    useEffect(() => {
        const getAllMedia = () => {
            let media = [...product.media];
            product.variants.forEach(variant => {
                media.push(...variant.media);
            });
            setMedia(media);
        };
        if (product && product.media) getAllMedia();
    }, [product]);

    useEffect(() => {
        if (product) {
            setSelectedVariant(getVariant(attribute, size));
            setValidAttributeOptions(getConfigurationCombinations('size', size));
            setValidSizeOptions(getConfigurationCombinations('attribute', attribute));
        }
    }, [attribute, size]);

    useEffect(() => {
        if (quantity !== customQuantity) setCustomQuantity(quantity);
    }, [quantity]);

    const addVariantToCart = () => {
        if (isLoggedInCustomer(auth)) {
            addToCart(auth.customer_id, auth.token, selectedVariant.id, quantity)
                .then(result => {
                    setCart(result);
                    history.push('/cart');
                })
                .catch(error => console.error(error));
        } else {
            // todo: redirect to login
            history.push('/login');
        }
    };

    const handleQuantityUpdate = () => {
        setQuantity(customQuantity);
        setIsCustomQuantity(false);
    };

    const checkIfSale = () => {
        let result = false;

        for (let i = 0; i < product.variants.length; i++) {
            const variant = product.variants[i];
            if (variant.discount && variant.discount > 0) {
                result = true;
                break;
            }
        }

        return result;
    };

    const retrieveOptions = (_which) => {
        let option = {};
        if (product[`${_which}_name`]) {
            let list = [];
            product.variants.forEach((variant) => {
                if (variant[_which] && !list.includes(variant[_which])) list.push(variant[_which]);
            });

            if (list.length) {
                return {
                    title: product[`${_which}_name`],
                    options: list
                };
            }
        }

        return option;
    };

    const getConfigurationCombinations = (which, value) => {
        let matches = [];
        if (which === 'attribute') {
            product.variants.forEach(variant => {
                if (variant.attribute === value && variant.size) matches.push(variant.size);
            });
        } else if (which === 'size') {
            product.variants.forEach(variant => {
                if (variant.size === value && variant.attribute) matches.push(variant.attribute);
            });
        }

        return matches;
    };

    const getVariant = (attribute, size) => {
        let productVariant = null;
        for (let i = 0; i < product.variants.length; i++) {
            const variant = product.variants[i];
            if (attribute && size) {
                if (variant.attribute === attribute && variant.size === size) productVariant = variant;
            } else if (attribute) {
                if (variant.attribute === attribute && !variant.size) productVariant = variant;
            } else if (size) {
                if (variant.size === size && !variant.attribute) productVariant = variant;
            }
        }
        return productVariant;
    };

    const handleAttributeSelected = attribute => setAttribute(attribute);
    const handleSizeSelected = size => setSize(size);

    useEffect(() => {
        if(product){
            handleAttributeSelected(retrieveOptions('attribute')?.options[0])
            handleSizeSelected(retrieveOptions('size')?.options[0])
        }
    }, [product]);

    const selectedConfiguration = () => {
        let attributeString = '';
        if (product.attribute_name) {
            const { options: attributeOptions } = retrieveOptions('attribute');
            if (attribute && attributeOptions && attributeOptions.length) {
                attributeString = `${attribute} ${product.attribute_name}`;
            }
        }

        let sizeString = '';
        if (product.size_name) {
            const { options: sizeOptions } = retrieveOptions('size');
            if (size && sizeOptions && sizeOptions.length) {
                sizeString = `${size} ${product.size_name}`;
            }
        }

        if (attributeString && sizeString) return `${attributeString} — ${sizeString}`;
        else if (attributeString) return attributeString;
        else if (sizeString) return sizeString;
    };

    const priceView = (variant, quantity) => {
        const isDiscounted = variant && variant.discount > 0 && variant.discount_expiration > 0;

        if (isDiscounted) {
            const currentPrice = variant.price * quantity;
            const amountToDiscount = ((variant.price / 100) * variant.discount) * quantity;
            const discountedAmount = formatPrice(currentPrice - amountToDiscount);

            return <>
                <span className="current">
                    {discountedAmount}
                </span>
                <span className="strikethrough"><s>{formatPrice(variant.price * quantity)}</s></span>
            </>;
        } else {
            return <span className="current">
                {variant ? formatPrice(variant.price * quantity) : '—'}
            </span>;
        }
    };

    return (
        <>
            {
                product
                    ?
                    <DetailWrapper>
                        <Layout>
                            <BackButtonContainer>
                                <BackButtonComponent onClick={() => history.goBack()}>Back</BackButtonComponent>
                            </BackButtonContainer>
                            {canvasWidth < 500 &&
                                <Title style={{ marginBottom: '2rem' }}>
                                    <Brand>{product.brand.name}</Brand>{` ${product.name}`}{`${selectedVariant && selectedVariant.description ? `, ${selectedVariant.description}` : ''}`}
                                </Title>

                            }
                            <div />
                            <ProductDetailsContainer>
                                <Slideshow media={media} width={canvasWidth} />
                                {canvasWidth > 500 &&

                                    <React.Fragment>
                                        {
                                            (product.aliases && product.aliases.length) && <AliasContainer>
                                                <span className="title">This item is also known as:</span>
                                                <span className="text">{
                                                    product.aliases.map((alias, index) => {
                                                        return <React.Fragment
                                                            key={`AliasItem_${index}`}>{`${alias}${(product.aliases.length - 1) === index ? '' : ', '}`}</React.Fragment>;
                                                    })
                                                }</span>
                                            </AliasContainer>
                                        }
                                    </React.Fragment>
                                }
                            </ProductDetailsContainer>
                            <ProductConfigurationContainer>
                                {canvasWidth > 500 &&

                                    <Title>
                                        <Brand>{product.brand.name}</Brand>{` ${product.name}`}{`${selectedVariant && selectedVariant.description ? `, ${selectedVariant.description}` : ''}`}
                                    </Title>
                                }
                                {canvasWidth > 500 &&

                                    <React.Fragment>

                                        <AttributeRow>
                                            <span className="title">Price:</span>
                                            <Price>{priceView(selectedVariant, quantity)}</Price>
                                        </AttributeRow>
                                        <Divider />
                                        <AttributeRow>
                                            <span className="title">Availability:</span>
                                            <StockLabel>In Stock</StockLabel>
                                        </AttributeRow>
                                    </React.Fragment>
                                }
                                <Option
                                    option={retrieveOptions('attribute')}
                                    matches={validAttributeOptions}
                                    onOptionClick={handleAttributeSelected}
                                    width={canvasWidth}
                                />
                                <Option
                                    option={retrieveOptions('size')}
                                    matches={validSizeOptions}
                                    onOptionClick={handleSizeSelected}
                                    width={canvasWidth}
                                />
                                {canvasWidth > 500 &&

                                    <AttributeRow>
                                        <span className="title">Selection:</span>
                                        <SelectionText>
                                            {selectedConfiguration() ? selectedConfiguration() : 'N/A'}
                                        </SelectionText>
                                    </AttributeRow>
                                }
                                {canvasWidth < 500 &&
                                    <AttributeRow style={{ width: '100%', justifyContent: 'space-between' }}>
                                        <Price>{priceView(selectedVariant, quantity)}</Price>
                                        <StockLabel>In Stock</StockLabel>
                                    </AttributeRow>
                                }
                                <QuantityContainer>
                                    <QuantityInnerContainer>
                                        <span>Quantity:</span>
                                        {
                                            (quantity > 9 || customQuantity > 9 || isCustomQuantity) ?
                                                <QuantityStepperContainer>
                                                    <input type="number" value={customQuantity}
                                                        onChange={e => setCustomQuantity(Number(e.target.value))} />
                                                    <button onClick={handleQuantityUpdate}>Update</button>
                                                </QuantityStepperContainer>
                                                :
                                                <DropdownContainer DropdownWidth={'12rem'} value={quantity} onChange={e => {
                                                    const { value } = e.target;

                                                    if (value === 'more') {
                                                        setIsCustomQuantity(true);
                                                        setCustomQuantity(quantity);
                                                    } else {
                                                        setQuantity(Number(value));
                                                    }
                                                }} style={{ marginBottom: '0.5rem', marginTop: '0.2rem' }}>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="more">10+</option>
                                                </DropdownContainer>
                                        }
                                        <AddCartButton disabled={!selectedVariant} onClick={addVariantToCart} styled={{ paddingTop: '1rem' }}>
                                            Add to Cart
                                    </AddCartButton>
                                    </QuantityInnerContainer>
                                </QuantityContainer>
                                {canvasWidth > 500 &&
                                    <React.Fragment>
                                        {
                                            (product.aliases && product.aliases.length) && <AliasContainer>
                                                <span className="title">This item is also known as:</span>
                                                <span className="text">{
                                                    product.aliases.map((alias, index) => {
                                                        return <React.Fragment
                                                            key={`AliasItem_${index}`}>{`${alias}${(product.aliases.length - 1) === index ? '' : ', '}`}</React.Fragment>;
                                                    })
                                                }</span>
                                            </AliasContainer>
                                        }
                                    </React.Fragment>
                                }
                            </ProductConfigurationContainer>

                        </Layout>
                        <Description />
                    </DetailWrapper>
                    :
                    <LoadingComponent />

            }
        </>
    );
}

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user,
    cart: state.cart
});
const mapDispatchToProps = {
    setCart
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
